import gql from "graphql-tag";

/**
 * searchUsersV2 — hardened search used behind searchV2Enabled.
 * Returns users + total so "Load more" paginates by real totals
 * (legacy search guessed with "results < 50").
 */
const searchUsersV2Query = gql`
  query searchUsersV2(
    $firstName: String
    $lastName: String
    $email: String
    $phone: String
    $term: String
    $companyId: String
    $offset: Int
    $limit: Int
  ) {
    searchUsersV2(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phone: $phone
      term: $term
      companyId: $companyId
      offset: $offset
      limit: $limit
    ) {
      users {
        _id
        firstName
        lastName
        email
        phone
        roles
        verified
        steps
        coins
        idNumber
        company {
          _id
          name
        }
      }
      total
      offset
      limit
    }
  }
`;

export default searchUsersV2Query;
